import setInboxRuleRequest from 'owa-service/lib/factory/setInboxRuleRequest';
import setInboxRuleOperation from 'owa-service/lib/operation/setInboxRuleOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
/**
 * Set inbox rule service
 * @param inboxRule the rule to update
 * @return SetInboxRuleResponse
 */
export default function setInboxRuleService(inboxRule, force, alwaysDeleteOutlookRulesBlob) {
    var requestBody = setInboxRuleRequest({
        Header: getJsonRequestHeader(),
        InboxRule: inboxRule,
    });
    requestBody.Force = force;
    requestBody.AlwaysDeleteOutlookRulesBlob = alwaysDeleteOutlookRulesBlob;
    return setInboxRuleOperation(requestBody);
}
//# sourceMappingURL=setInboxRuleService.js.map